import { render, staticRenderFns } from "./ContactTabsContainer.vue?vue&type=template&id=645c5c88&scoped=true&"
import script from "./ContactTabsContainer.vue?vue&type=script&lang=js&"
export * from "./ContactTabsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c5c88",
  null
  
)

export default component.exports